var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _typeof = typeof Symbol === "function" && typeof Symbol.iterator === "symbol" ? function (obj) { return typeof obj; } : function (obj) { return obj && typeof Symbol === "function" && obj.constructor === Symbol && obj !== Symbol.prototype ? "symbol" : typeof obj; };

/* eslint-disable no-console */

/**
 * @param {string} format
 * @param {Array<any>} args
 * @returns {string}
 */
export function formatMessage(format) {
  for (var _len = arguments.length, args = Array(_len > 1 ? _len - 1 : 0), _key = 1; _key < _len; _key++) {
    args[_key - 1] = arguments[_key];
  }

  var lastIndex = 0;
  return format.replace(/%s/g, function () {
    return String(args[lastIndex++]);
  });
}

/**
 * Copyright 2013-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Use invariant() to assert state which your program assumes to be true.
 *
 * Provide sprintf-style format (only %s is supported) and arguments to provide
 * information about what broke and what you were expecting.
 *
 * The invariant message will be stripped in production, but the invariant will
 * remain to ensure logic does not differ in production.
 *
 * @param {any} condition
 * @param {string} format
 * @param {Array<any>} args
 * @returns {void}
 */
export function invariant(condition, format) {
  if (process.env.NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('invariant(...): Second argument must be a string.');
    }
  }
  if (!condition) {
    var error = void 0;
    if (format === undefined) {
      error = new Error('Minified exception occurred; use the non-minified dev environment ' + 'for the full error message and additional helpful warnings.');
    } else {
      for (var _len2 = arguments.length, args = Array(_len2 > 2 ? _len2 - 2 : 0), _key2 = 2; _key2 < _len2; _key2++) {
        args[_key2 - 2] = arguments[_key2];
      }

      error = new Error(formatMessage.apply(undefined, [format].concat(args)));
      error.name = 'Invariant Violation';
    }
    error.framesToPop = 1;
    throw error;
  }
}

/**
 * Copyright 2014-2015, Facebook, Inc.
 * All rights reserved.
 *
 * This source code is licensed under the BSD-style license found in the
 * LICENSE file in the root directory of this source tree. An additional grant
 * of patent rights can be found in the PATENTS file in the same directory.
 *
 * Similar to invariant but only logs a warning if the condition is not met.
 * This can be used to log issues in development environments in critical
 * paths. Removing the logging code for production environments will keep the
 * same logic and follow the same code paths.
 *
 * @param {any} condition
 * @param {string} format
 * @param {Array<any>} args
 * @returns {void}
 */
export function warning(condition, format) {
  if (process.env.NODE_ENV !== 'production') {
    if (format === undefined) {
      throw new Error('warning(...): Second argument must be a string.');
    }
    if (!condition) {
      for (var _len3 = arguments.length, args = Array(_len3 > 2 ? _len3 - 2 : 0), _key3 = 2; _key3 < _len3; _key3++) {
        args[_key3 - 2] = arguments[_key3];
      }

      var message = 'Warning: ' + formatMessage.apply(undefined, [format].concat(args));
      if (typeof console !== 'undefined') {
        console.error(message);
      }
      try {
        // This error was thrown as a convenience so that you can use this stack
        // to find the callsite that caused this warning to fire.
        throw new Error(message);
      } catch (err) {} // eslint-disable-line no-empty
    }
  }
}

/**
 * @param {function:object} next
 * @returns {function:object}
 */
export function pendingActionEnhancer(next) {
  invariant(typeof next === 'function', 'next expected a function, instead received %s.', next);

  return function (payload) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    invariant((typeof extra === 'undefined' ? 'undefined' : _typeof(extra)) === 'object' && extra !== null, 'extra expected a object, instead received %s.', extra);

    var meta = extra.meta;


    return next(payload, _extends({}, extra, {
      meta: _extends({}, meta, {
        pending: true
      })
    }));
  };
}

/**
 * @param {function:object} next
 * @returns {function:object}
 */
export function errorActionEnhancer(next) {
  invariant(typeof next === 'function', 'next expected a function, instead received %s.', next);

  return function (payload) {
    var extra = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : {};

    invariant((typeof extra === 'undefined' ? 'undefined' : _typeof(extra)) === 'object' && extra !== null, 'extra expected a object, instead received %s.', extra);

    return next(payload, _extends({}, extra, {
      error: true
    }));
  };
}

/**
 * @param {function} next
 * @returns {function:object}
 */
export function statusStateEnhancer(next) {
  invariant(typeof next === 'function', 'next expected a function, instead received %s.', next);

  return function (state, action) {
    var _action$meta = action.meta;
    _action$meta = _action$meta === undefined ? {} : _action$meta;
    var pending = _action$meta.pending,
        error = action.error;


    if (pending || error) {
      invariant((typeof state === 'undefined' ? 'undefined' : _typeof(state)) === 'object' && state !== null, 'state expected a non-null object, instead received %s.', state);

      var pendingState = state.pending;


      if (pendingState === undefined) {
        return state;
      }

      return pending ? _extends({}, state, {
        pending: true
      }) : _extends({}, state, {
        pending: false
      });
    }

    return next(state, action);
  };
}

/**
 * @param {string} type
 * @param {string|void} prefix
 * @returns {string}
 */
export function defaultGetActionType(type, prefix) {
  invariant(typeof type === 'string', 'type expected a string, instead received %s.', type);

  return prefix === undefined ? type : prefix + '/' + type;
}

/**
 * @param {string} type
 * @returns {function:object}
 */
export function defaultCreatActionCreator(type) {
  invariant(typeof type === 'string', 'type expected a string, instead received %s.', type);

  return function (payload, extra) {
    return _extends({}, extra, {
      type: type,
      payload: payload
    });
  };
}

/**
 * @function
 * @param {object} state
 * @param {object} action
 * @returns {object}
 */
export var defaultActionHandle = statusStateEnhancer(function (state, action) {
  invariant((typeof state === 'undefined' ? 'undefined' : _typeof(state)) === 'object' && state !== null, 'state expected a non-null object, instead received %s.', state);

  var payload = action.payload;
  var pending = state.pending;


  if (pending === undefined) {
    return _extends({}, state, payload);
  }

  return _extends({}, state, payload, {
    pending: false
  });
});

/**
 * @param {object} [options={}]
 * @param {string|void} options.prefix
 * @param {any} [options.initialState={}]
 * @param {function:string} [options.getActionType=defaultGetActionType]
 * @param {function:object} [options.actionHandle=defaultActionHandle]
 * @param {function:function} [options.createActionCreator=defaultCreatActionCreator]
 * @param {function:function} [options.createPendingActionCreator=pendingActionEnhancer]
 * @param {function:function} [options.createErrorActionCreator=errorActionEnhancer]
 * @returns {function:any}
 */
export function createReducer() {
  var options = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : {};
  var prefix = options.prefix,
      _options$initialState = options.initialState,
      initialState = _options$initialState === undefined ? {} : _options$initialState,
      _options$getActionTyp = options.getActionType,
      getActionType = _options$getActionTyp === undefined ? defaultGetActionType : _options$getActionTyp,
      _options$actionHandle = options.actionHandle,
      actionHandle = _options$actionHandle === undefined ? defaultActionHandle : _options$actionHandle,
      _options$createAction = options.createActionCreator,
      createActionCreator = _options$createAction === undefined ? defaultCreatActionCreator : _options$createAction,
      _options$createPendin = options.createPendingActionCreator,
      createPendingActionCreator = _options$createPendin === undefined ? pendingActionEnhancer : _options$createPendin,
      _options$createErrorA = options.createErrorActionCreator,
      createErrorActionCreator = _options$createErrorA === undefined ? errorActionEnhancer : _options$createErrorA;


  invariant(typeof getActionType === 'function', 'options.getActionType expected a function, instead received %s.', getActionType);

  invariant(typeof createActionCreator === 'function', 'options.createActionCreator expected a function, instead received %s.', createActionCreator);

  invariant(typeof createPendingActionCreator === 'function', 'options.createPendingActionCreator expected a function, instead received %s.', createPendingActionCreator);

  invariant(typeof createErrorActionCreator === 'function', 'options.createErrorActionCreator expected a function, instead received %s.', createErrorActionCreator);

  invariant(typeof actionHandle === 'function', 'options.actionHandle expected a function, instead received %s.', actionHandle);

  /**
   * @inner
   * @var {Object.<string, function>}
   */
  var _handles = {};

  /**
   * @param {any} state
   * @param {object} action
   * @param {string} action.type
   * @param {any} action.payload
   * @param {boolean|void} action.error
   * @param {object|void} action.meta
   * @returns {object}
   */
  function reducer() {
    var state = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : initialState;
    var action = arguments[1];

    var handle = _handles[action.type];
    return handle ? handle(state, action) : state;
  }

  /**
   * @returns {Object.<string, function>}
   */
  function getHandles() {
    return _handles;
  }

  /**
   * @param {string} type
   * @param {function:any} handle
   * @param {function:function|void} enhancer
   * @returns {function:object}
   */
  function register(type) {
    var handle = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : actionHandle;
    var enhancer = arguments[2];

    invariant(typeof type === 'string', 'type expected a string, instead received %s.', type);

    invariant(typeof handle === 'function', 'handle expected a function, instead received %s.', handle);

    invariant(!enhancer || typeof enhancer === 'function', 'enhancer expected a function, instead received %s.', enhancer);

    var actionType = getActionType(type, prefix);

    invariant(typeof actionType === 'string', 'options.getActionType expected a function return a string, instead returned %s.', actionType);

    var _actionCreator = createActionCreator(actionType);

    invariant(typeof _actionCreator === 'function', 'options.createActionCreator expected a function return a function, instead returned %s.', _actionCreator);

    var _pendingActionCreator = createPendingActionCreator(_actionCreator);

    invariant(typeof _pendingActionCreator === 'function', 'options.createPendingActionCreator expected a function return a function, instead returned %s.', _pendingActionCreator);

    var _errorActionCreator = createErrorActionCreator(_actionCreator);

    invariant(typeof _errorActionCreator === 'function', 'options.createErrorActionCreator expected a function return a function, instead returned %s.', _errorActionCreator);

    if (enhancer !== undefined) {
      _actionCreator = enhancer(_actionCreator);

      invariant(typeof _actionCreator === 'function', 'enhancer expected a function return a function, instead returned %s.', _actionCreator);

      _pendingActionCreator = enhancer(_pendingActionCreator);

      invariant(typeof _pendingActionCreator === 'function', 'enhancer expected a function return a function, instead returned %s.', _pendingActionCreator);

      _errorActionCreator = enhancer(_errorActionCreator);

      invariant(typeof _errorActionCreator === 'function', 'enhancer expected a function return a function, instead returned %s.', _errorActionCreator);
    }

    var actionCreator = _actionCreator;
    actionCreator.pending = _pendingActionCreator;
    actionCreator.error = _errorActionCreator;
    actionCreator.type = type;
    actionCreator.actionType = actionType;

    warning(_handles[actionType] === undefined || _handles[actionType] === handle, 'register overwrite "%s" action handle with a new handle.', actionType);

    _handles[actionType] = handle;

    return actionCreator;
  }

  reducer.getHandles = getHandles;
  reducer.register = register;

  return reducer;
}


// WEBPACK FOOTER //
// ./node_modules/re-reducer/es/index.js